import { isCrawler, siteLocale } from './pwa';

// How many people install the app (docs/pwa.md), counted by Meu Treino itself: analytics run only after cookie consent,
// and the iPhone never tells a page it was installed. The beacon carries only what happened, the platform, the site
// and, for a tap, where; the server adds 1 to that day's total. Nothing about the person, so no consent is asked.
// Never sent for crawlers; never throws.

/** localStorage: when the installed app first opened on this device (the first-open beacon goes once). */
export const APP_FIRST_OPEN_KEY = 'mt-app-first-open-at';

const apiOrigin = () => String(import.meta.env.VITE_GRAPHQL_URL || '').replace(/\/graphql$/, '');
export const appEventsUrl = () => `${apiOrigin()}/api/app-events`;

export const appEventBody = (kind, platform, source, site = siteLocale()) =>
  kind === 'install-click' && source ? { kind, platform, source, site } : { kind, platform, site };

export const countAppEvent = (kind, platform, source) => {
  if (isCrawler(navigator.userAgent)) return;
  try {
    // text/plain: a simple request, with no CORS preflight before it
    fetch(appEventsUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify(appEventBody(kind, platform, source)),
      keepalive: true,
      credentials: 'omit',
    }).catch(() => undefined);
  } catch {
    // No fetch: nothing to count
  }
};

/** The installed app's first launch on this device: counted once (true when this call counted it). */
export const countFirstOpen = (platform, now = Date.now()) => {
  try {
    if (window.localStorage.getItem(APP_FIRST_OPEN_KEY)) return false;
    window.localStorage.setItem(APP_FIRST_OPEN_KEY, String(now));
  } catch {
    // No storage: not counted (it would count every launch)
    return false;
  }
  countAppEvent('first-open', platform);
  return true;
};
